
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";
import { cn } from "@/lib/utils";
import { Capacitor } from '@capacitor/core';

interface AirportHeaderProps {
  name: string;
  iata_code: string | null;
  location: string;
  favoriteButton?: React.ReactNode;
}

export const AirportHeader = ({ name, iata_code, location, favoriteButton }: AirportHeaderProps) => {
  const { t } = useTranslation();
  const isIOS = Capacitor.getPlatform() === 'ios';
  
  return (
    <div className={cn(
      "flex items-start gap-4"
      // Removed the ios-safe-area-top class here as we're handling it at the body level now
    )}>
      <Link to="/">
        <Button variant="outline" size="icon">
          <ArrowLeft className="h-4 w-4" />
        </Button>
      </Link>
      <div className="flex-grow">
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-bold">
            {t(name) || name}
            {iata_code && (
              <span className="ml-2 text-lg text-muted-foreground">
                ({iata_code})
              </span>
            )}
          </h1>
          {favoriteButton}
        </div>
        <p className="text-muted-foreground">{t(location) || location}</p>
      </div>
    </div>
  );
};
